import { LOGO_URL } from "../lib/data";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-black">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Event Monk" className="h-10 w-10 object-contain" />
              <div className="leading-none">
                <div className="font-display font-bold text-base tracking-tight">EVENT MONK</div>
                <div className="font-mono-em text-[0.62rem] tracking-[0.24em] uppercase text-white/50 mt-1">
                  Events Reimagined
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-white/60 leading-relaxed">
              Independent live experience studio based in Kochi, India. Building
              festivals, launches and brand chapters that people re-watch.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <a href="https://www.instagram.com/event.monk" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 pl-3 pr-4 py-2 border border-white/15 rounded-full hover:border-white transition-colors duration-500" aria-label="Instagram" data-testid="social-instagram"><Instagram size={16} /><span className="font-mono-em text-[0.7rem] tracking-[0.22em] uppercase">@event.monk</span></a>
            </div>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="font-mono-em text-[0.7rem] tracking-[0.24em] uppercase text-white/50">Navigate</div>
            <ul className="mt-5 space-y-3">
              <li><a href="#services" className="em-underline-link">Services</a></li>
              <li><a href="#work" className="em-underline-link">Work</a></li>
              <li><a href="#manifesto" className="em-underline-link">Manifesto</a></li>
              <li><a href="#journal" className="em-underline-link">Journal</a></li>
              <li><a href="#contact" className="em-underline-link">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="font-mono-em text-[0.7rem] tracking-[0.24em] uppercase text-white/50">Verticals</div>
            <ul className="mt-5 space-y-3 text-white/80">
              <li>Music Festivals</li>
              <li>Corporate</li>
              <li>Bespoke</li>
              <li>Artist Mgmt</li>
              <li>Venues</li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="font-mono-em text-[0.7rem] tracking-[0.24em] uppercase text-white/50">Studio</div>
            <div className="mt-5 text-white/80 leading-snug">
              Suite 805, Level 2 — KC Arcade,<br/>
              Thuthiyoor Road, Kakkanad,<br/>
              Kochi, India — 682 030
            </div>
            <div className="mt-5 space-y-1">
              <a href="mailto:support@eventmonk.in" className="block em-underline-link">support@eventmonk.in</a>
              <a href="tel:+919562451105" className="block em-underline-link">+91 95624 51105</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-wrap gap-4 items-center justify-between text-white/50 font-mono-em text-[0.68rem] tracking-[0.22em] uppercase">
          <span>© {new Date().getFullYear()} Eventmonkpro Pvt. Ltd.</span>
          <span>Kochi · 12°58′N 76°16′E</span>
          <span>Made loud, edited tight.</span>
        </div>
      </div>
    </footer>
  );
}
